module.exports = __webpack_public_path__ + "img/soon.0b786aa7.jpg";